import {
  FlagMarker,
  MemberCreateRequest,
  MemberDetails,
  MemberSourceRegistrationCd,
  MemberUpdateRequest
} from '../../@types/Members';

export const memberIsEligibleForUpdates = ({ mrnSourceClassificationCd }: MemberDetails): boolean =>
  mrnSourceClassificationCd === MemberSourceRegistrationCd.CLIENT_COMMERCIAL ||
  mrnSourceClassificationCd === MemberSourceRegistrationCd.ELIGIBILITY;

export const isPrimaryMember = ({ primaryFlg }: MemberUpdateRequest | MemberCreateRequest): boolean =>
  primaryFlg === FlagMarker.Y;

export const memberHasIndividual = ({ individualId }: MemberDetails): boolean => !!individualId;
